import { schema } from 'normalizr';
var bankSchema = new schema.Entity('banks');
var bankEntrySchema = new schema.Entity('bankEntries');
var interactionTypeSchema = new schema.Entity('interactionTypes');
var itemAnalysisSchema = new schema.Entity('itemAnalyses', {}, {
  idAttribute: 'item_id'
});
var quizAnalysisSchema = new schema.Entity('quizAnalyses', {}, {
  idAttribute: 'quiz_id'
});
var itemSchema = new schema.Entity('items');
var qtiImportSchema = new schema.Entity('qtiImports');
var quizSchema = new schema.Entity('quizzes');
var quizSessionEventSchema = new schema.Entity('quizSessionEvents', {}, {
  idAttribute: 'created_at' // indexed by createdAt
});
var shareBankSchema = new schema.Entity('sharedBanks');
var quizSessionResultSchema = new schema.Entity('quizSessionResults');
var quizSessionSchema = new schema.Entity('quizSessions');
var quizEntrySchema = new schema.Entity('quizEntry');
var quizEntriesSchema = new schema.Entity('quizEntries');
var resumeDataSchema = new schema.Entity('resumeData');
var sessionItemResultSchema = new schema.Entity('sessionItemResults');
var sessionItemSchema = new schema.Entity('sessionItems');
var stimulusSchema = new schema.Entity('stimuli');

// =================
//   relationships
// =================

bankEntrySchema.define({
  entry: new schema.Union({
    Item: itemSchema,
    Stimulus: stimulusSchema
  }, function (value, parent, key) {
    return parent.entry_type;
  })
});
itemSchema.define({
  interaction_type: interactionTypeSchema
});
stimulusSchema.define({});
quizSchema.define({
  items: [itemSchema],
  // Probably shouldn't have this at the root anymore...
  quizEntries: [quizEntrySchema],
  itemAnalyses: [itemAnalysisSchema],
  quizAnalysis: quizAnalysisSchema
});
var quizEntryNestedDef = {
  interaction_types: [interactionTypeSchema],
  entry: new schema.Union({
    Bank: bankSchema,
    BankEntry: bankEntrySchema,
    Item: itemSchema,
    Stimulus: stimulusSchema
  }, function (value, parent, key) {
    return parent.entry_type;
  })
};
quizEntrySchema.define(quizEntryNestedDef);
quizEntriesSchema.define(quizEntryNestedDef);

// 'item' is within the sessionItem, but it should remain
// denormalized because sessionItems of the same id can
// actually represent different objects
// however we do want to normalize the interaction types
// within it
sessionItemSchema.define({
  item: {
    interaction_type: interactionTypeSchema
  }
});
sessionItemResultSchema.define({
  quiz_session: quizSessionSchema,
  session_items: [sessionItemSchema]
});
quizSessionSchema.define({
  authoritative_result: quizSessionResultSchema,
  quiz: quizSchema,
  quiz_session_results: [quizSessionResultSchema]
});
quizSessionEventSchema.define({
  quiz_session: quizSessionSchema
});
export { bankEntrySchema, bankSchema, interactionTypeSchema, itemAnalysisSchema, itemSchema, qtiImportSchema, quizAnalysisSchema, quizEntriesSchema, quizEntrySchema, quizSchema, quizSessionEventSchema, quizSessionResultSchema, quizSessionSchema, resumeDataSchema, shareBankSchema, sessionItemResultSchema, sessionItemSchema, stimulusSchema };